<template>
  <section
    class="component-home-banner text-center pt-md-5 chb-bg mt-lg-0 mt-md-5"
    :class="headingEnabled ? 'pt-3' : ''"
    resmed-component-name="fsn-banner"
    v-bind:style="{ background: data.layout_options['background'], color: data.layout_options['color'], 'background-image': 'url('+ data.background_image +')', 'padding':'30px 0px', 'background-size':'cover'}"
  >
    <div class="component container-fluid px-xs-sm-2" :class="headingEnabled ? 'custom-border' : ''"  >
      <div class="container" v-if="headingEnabled" style="padding:20px;">
        <!-- <p class="intro mb-3 pt-lg-4 pt-3">{{ data.introduction }}</p> -->
        <h1 class="mb-3 text-white">{{ $getTranslation(data.heading, $route.params.region) }}</h1>
          <p class="col-12 col-md-12 col-lg-6 m-auto" style="font-size: 14px;" v-if="data.introduction">{{ data.introduction }}</p>
      </div>
      <div class="row pb-5 pb-md-0" :class="headingEnabled ? 'd-block' : 'd-md-block d-none'" style="margin:20px 0px;">
        <div class="col-md-10 col-lg-12 mx-auto">
          <div class="autocomplete" style="width:300px;"> 
            
    <input id="searchInput" type="text" class="SearchCountry" name="Country"  placeholder="Start typing to select a country">
  </div>
          <!-- <search-form :showSearchIcon="headingEnabled" :options="data.all_products.products" listCat="true"></search-form> -->
        </div>
      </div>
    </div>
  </section>
</template>
​
<script>
import { mapMutations } from 'vuex';
import navigationCard from "./navigation-card";
export default {
  name: "fsn-banner",
  props: ["data"],
  data() {
    return {
      siteRegion: "",
    }
  },
  computed: {
    headingEnabled() {
      return this.data.enabled[0] === "true";
    },
  },
  methods: {
    ...mapMutations(['setShowLinks']),
    filterDocuments()
    {
      
      var country = document.getElementById('searchInput').value
      if(!country || country === ""){this.file_details = this.acf.files}
      else{
      this.file_details = this.acf.files.filter(x=> x.language===country)
      }
      window.filterDocuments = this;
    },
  },
  created() {
    this.setShowLinks(false)
  },
  mounted() {
    autocomplete(document.getElementsByClassName("SearchCountry")[0], this.data.countries);
  }
};

/*AUTO COMPLETE SCRIPTS*/
function autocomplete(inp, arr) {
  /*the autocomplete function takes two arguments,
  the text field element and an array of possible autocompleted values:*/
  var currentFocus;
  /*execute a function when someone writes in the text field:*/
  inp.addEventListener("input", function(e) {
      var a, b, i, val = this.value;
      /*close any already open lists of autocompleted values*/
      closeAllLists();
      if (!val) { window.filterDocuments.filterDocuments(); return false;}
      currentFocus = -1;
      /*create a DIV element that will contain the items (values):*/
      a = document.createElement("DIV");
      a.setAttribute("id", this.id + "autocomplete-list");
      a.setAttribute("class", "autocomplete-items");
      /*append the DIV element as a child of the autocomplete container:*/
      this.parentNode.appendChild(a);
      /*for each item in the array...*/
      for (i = 0; i < arr.length; i++) {
        /*check if the item starts with the same letters as the text field value:*/
        if (arr[i].substr(0, val.length).toUpperCase() == val.toUpperCase()) {
          /*create a DIV element for each matching element:*/
          b = document.createElement("DIV");
          b.setAttribute("class", "autocomplete-items-padding");
          this.setAttribute("class", "auto-radius-btm-0");
          /*make the matching letters bold:*/
          b.innerHTML = "<strong>" + arr[i].substr(0, val.length) + "</strong>";
          b.innerHTML += arr[i].substr(val.length);
          /*insert a input field that will hold the current array item's value:*/
          b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
          /*execute a function when someone clicks on the item value (DIV element):*/
              b.addEventListener("click", function(e) {
              /*insert the value for the autocomplete text field:*/
              inp.value = this.getElementsByTagName("input")[0].value;
              /*close the list of autocompleted values,
              (or any other open lists of autocompleted values:*/
              closeAllLists();
              // CALL filter function here
              window.filterDocuments.filterDocuments();
          });
          a.appendChild(b);
        }
      }
  });
  /*execute a function presses a key on the keyboard:*/
  inp.addEventListener("keydown", function(e) {

      var x = document.getElementById(this.id + "autocomplete-list");
      if (x) x = x.getElementsByTagName("div");
      if (e.keyCode == 40) {
        /*If the arrow DOWN key is pressed,
        increase the currentFocus variable:*/
        currentFocus++;
        /*and and make the current item more visible:*/
        addActive(x);
      } else if (e.keyCode == 38) { //up
        /*If the arrow UP key is pressed,
        decrease the currentFocus variable:*/
        currentFocus--;
        /*and and make the current item more visible:*/
        addActive(x);
      } else if (e.keyCode == 13) {
        /*If the ENTER key is pressed, prevent the form from being submitted,*/
        e.preventDefault();
        if (currentFocus > -1) {
          /*and simulate a click on the "active" item:*/
          if (x) x[currentFocus].click();
        }
      }
  });
  function addActive(x) {
    /*a function to classify an item as "active":*/
    if (!x) return false;
    /*start by removing the "active" class on all items:*/
    removeActive(x);
    if (currentFocus >= x.length) currentFocus = 0;
    if (currentFocus < 0) currentFocus = (x.length - 1);
    /*add class "autocomplete-active":*/
    x[currentFocus].classList.add("autocomplete-active");
    x[currentFocus].style = {"background-color":"orange"} 
  }
  function removeActive(x) {
    /*a function to remove the "active" class from all autocomplete items:*/
    for (var i = 0; i < x.length; i++) {
      x[i].classList.remove("autocomplete-active");
    }
  }
  function closeAllLists(elmnt) {
    /*close all autocomplete lists in the document,
    except the one passed as an argument:*/
    var x = document.getElementsByClassName("autocomplete-items");
    for (var i = 0; i < x.length; i++) {
      if (elmnt != x[i] && elmnt != inp) {
      x[i].parentNode.removeChild(x[i]);
    }
    document.getElementById('searchInput').classList.remove("auto-radius-btm-0")
  }
}
/*execute a function when someone clicks in the document:*/
document.addEventListener("click", function (e) {
    closeAllLists(e.target);
});
}

</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
.component-home-banner {
  .custom-border {
    @media (max-width: 550px) {
      border-top: 2px solid #fff;
      margin-top: 52px;
    }
  }
  .intro {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 500;
    &::before {
      content: "";
      display: block;
      width: 1.25rem;
      border-top: 3px solid #fff;
      border-radius: 5.5px;
      margin: -3px auto 16px;
    }
  }

  .categories {
    margin-top: 1rem;
    margin-right:-10px;
    margin-left:-10px;
    padding: 1rem;
    font-family: "Plus Jakarta Sans", Arial, sans-serif;
    a {
      color: #fff;
      cursor: pointer;
      padding: 0px 20px;
    }
  }

  .chb-bg{
    background-size: cover !important;
  }
}
>>> .autocomplete {
  /*the container must be positioned relative:*/
  position: relative;
  display: inline-block;
  background-color: white;
  color:black;
  border-radius:25px;
  
}
>>> .autocomplete-items-padding
{
  padding:10px;
  text-align:left;
  padding-left:25px;
}
>>> .autocomplete-active {
  /*the container must be positioned relative:*/
  background-color:#d1d1d1 !important;
  
}
>>> #searchInput{
  padding-left:25px;
}
 input {
  border: 1px solid transparent;
  background-color: #f1f1f3;
  padding: 10px;
  font-size: 16px;
}
 input[type=text] {
  background-color: #f1f1f2;
  width: 100%;
  border-radius:25px;
}
>>> .autocomplete-items {
  position: absolute !important;
  border: 1px solid #f1f1f3;
  border-bottom: none;
  background-color:#e1e1e1;
  border-top: none;
  padding:0px;
  z-index: 99;
  cursor:pointer;
  /*position the autocomplete items to be the same width as the container:*/
  top: 100%;
  left: 0;
  right: 0;

}
 .autocomplete-items div {
  position: absolute;
  padding: 10px;
  cursor: pointer;
  background-color: #fff;
  border-bottom: 1px solid #d4d4d4;
  background-color: white;
  color:black;
  
}
.auto-radius-25 {
  border-radius:25px;
}
>>> .auto-radius-btm-0
{
  border-bottom-left-radius:0px !important;
  border-bottom-right-radius:0px !important;
}
 >>> .autocomplete-items div:hover {
  /*when hovering an item:*/
  background-color: #d1d1d1;// #e9e9e9;
}
 div.autocomplete-active {
  /*when navigating through the items using the arrow keys:*/
  background-color: DodgerBlue !important;
  color: #ffffff !important;
}

 .select-overlay-container > select {
  border-radius: 50px;
  border: 1px solid #c00340;
  padding: 4px 6px;
  min-width: 100px;
  height: 26px;
  font-size: 12px;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 25px;
  background-image: url("#{$assets}/images/icon-down-caret-black.svg");
  background-repeat: no-repeat;
  background-position: 90%;
  background-size: 16px;
}

>>> .disable-pointer-events {
  pointer-events: none;
  color: #999;
}

>>> .select-overlay-container {
  position: relative;
  display: inline-block;
  margin-top: 9px;
}

>>> .select-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.64);
  pointer-events: none;
  border-radius: 50px;
  height: 100%;
  width: fit-content;
  z-index: 1;
}
</style>
